import React, {useEffect} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/contact.js';
import { useDispatch, useSelector, connect } from 'react-redux';
import { getContacts, showLoading, hideLoading } from '../../redux/actions/contact';
import axios from 'axios';

function Contact() {
   
    const contacts = useSelector(state => state.allContacts.contacts);

    const dispatch = useDispatch();

    useEffect(() => {
        document.title = 'Contact | REAL FM';
    });
    useEffect(() => {
        const fetchAllContacts = async () => {
            dispatch(showLoading());
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/contacts/find-all`).then((res) => {
                dispatch(getContacts(res.data));
                dispatch(hideLoading());

            }).catch(error => {
                console.error(error);
            });
        };
        fetchAllContacts();
    }, [dispatch]);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Contact Us" />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                    <div className="contact-box-title">
                                    <h4>Contact Info</h4>
                                </div>
                        <Row>
                        {
                            contacts !== null && contacts.length > 0 ? contacts.map((contact, i) => (
                                <Col md="6" key={i} className="card contact-card">
                                
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-user"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{contact.contactName}</h5>
                                        <p>{contact.designation}</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{contact.phoneOne}</h5>
                                        <h5>{contact.phoneTwo}</h5>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5 className="mail-add"  onClick={() => window.location = `mailto:${contact.emailOne}?subject=Email From Website&body=Dear Concerned, %0A <Write your details here>`}>
                                        {contact.emailOne}</h5>
                                    </div>
                                </div>
                                <div className="contact-logo-info">
                                
                                    <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="" className="img-fluid" />
                                </div>
                             </Col>
                            )): "No contact found"
                        }
                            {/* <Col md="6">
                                
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-user"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Murray Cameron</h5>
                                        <p>Director</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>9930 0730</h5>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5 className="mail-add"  onClick={() => window.location = 'mailto:mcameron@realfm.net.au?subject=Email From Website&body=Dear Concerned, %0A <Write your details here>'}>mcameron@realfm.net.au</h5>
                                    </div>
                                </div>
                                <div className="contact-logo-info">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="" className="img-fluid" />
                                </div>
                            </Col> */}
                            
                            {/* <Col md="6">
                                
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-user"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Wendy Kenny</h5>
                                        <p>Business Development Manager</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>0411 406 481</h5>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5 className="mail-add" onClick={() => window.location = 'mailto:bdm@realfm.net.au?subject=Email From Website&body=Dear Concerned, %0A <Write your details here>'}>bdm@realfm.net.au</h5>
                                    </div>
                                </div>
                                <div className="contact-logo-info">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="" className="img-fluid" />
                                </div>
                                
                            </Col> */}
                        
                        </Row>
                    </Container>

                 
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    )
}

export default Contact